export const ACCOUNT_ID_HEADER = 'X-ACCOUNT-ID';
